import AuthService from '../../services/AuthService'
import router from '../../router'

const state = () => ({
    isAuthenticated: false,
    loadingUser: false,
    redirect: '/',
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user')) || null,
})
  
const mutations = {
    REDIRECT: (state, payload) => {
        state.redirect = payload;
    },
    SET_USER: (state, payload) => {
        localStorage.setItem('token', payload.token)
        localStorage.setItem('user', JSON.stringify(payload));

        const backPage = state.redirect
        state.redirect = '/'
        state.isAuthenticated = true;
        state.user = payload
        state.token = payload.token
        if(router.currentRoute.path === '/auth' && !backPage){
            router.push({path: `/`});
        }else{
            router.push({path: `${backPage}`});
        }
        state.redirect = '/';
    },
    AUTH_USER: (state, payload) => {
        localStorage.setItem('token', payload.token)
        localStorage.setItem('user', JSON.stringify(payload));
       
        state.isAuthenticated = true;
        state.user = payload;
    },
    SET_LOADING_USER: (state, payload) => {
        state.loadingUser = payload
    },
    LOG_USER_OUT(state){
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('notifications');
        localStorage.removeItem('subjects');
        localStorage.removeItem('aulasAssistidas');
        localStorage.removeItem('pages');
        localStorage.removeItem('page');
        state.token = null;
        state.isAuthenticated = false;
        state.user = null;
        state.notifications = [];
        state.redirect = '/';
        if(router.currentRoute.value.path !== '/auth'){
            router.push({path: `/auth`});
        }
    },
}

const actions = {
    async loginUser({commit, dispatch}, credentials ){
        try {
            commit('SET_LOADING_USER', true);
            const response = await AuthService.login(credentials);
            await commit('SET_USER', response.data);
            dispatch('fetchSubjects', { keyword: ''})
            dispatch('notificationsUser')
            commit('SET_LOADING_USER', false);
        } catch (error) {
            commit('SET_LOADING_USER', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async registerUser({commit}, credentials){
        try{
            commit('SET_LOADING_USER', true);
            const response = await AuthService.create(credentials);
            commit('SET_USER', response.data);
            commit('SET_LOADING_USER', false);
        }catch(error){
            commit('SET_LOADING_USER', false);
            commit('LOG_USER_OUT')
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchUser({commit}){
        try{
            commit('SET_LOADING_USER', true)
            const response = await AuthService.getUser();
            commit('AUTH_USER', response.data)
            commit('SET_LOADING_USER', false)
        } catch (error) {
            commit('SET_LOADING_USER', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updateUser({commit}, payload){
        try {
            const response = await AuthService.update(payload);
            commit('SET_USER', response.data);
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getUser: state => state.user,
    getLoadingUser: state => state.loadingUser,
}

export default {
    state,
    getters,
    mutations,
    actions
};